import { QuotedExpiredSidePanel } from 'components/secondaryMarket/live/sidePanel/quoted/QuotedExpiredSidePanel';
import { connect } from 'react-redux';
import type { FormOwnProps } from 'shared/connect/connect';
import { liveSelectors } from 'state/secondaryMarket/live/live.selector';
import { getLiveQuotePriceType } from 'state/secondaryMarket/live/quote/liveQuote.selector';
import {
  secondaryMarketLiveQuoteCancelRequestedThunk,
  secondaryMarketLiveRepriceQuoteThunk,
} from 'state/secondaryMarket/live/quote/liveQuote.thunk';
import { liveReferentialSelectors } from 'state/secondaryMarket/live/referential/liveReferential.selector';
import type { SecondaryPriceType } from 'state/secondaryMarket/productSearch/productSearch.model';
import type { ThunkDispatch } from 'state/state.common';
import type { AppState } from 'state/state.model';

type QuotedExpiredSidePanelStateProps = {
  price: number;
  priceCurrency: string;
  priceType: SecondaryPriceType;
};

type QuotedExpiredSidePanelDispatchProps = {
  onDone: () => void;
  onReprice?: () => void;
};

type QuotedExpiredSidePanelOwnProps = FormOwnProps;

export type QuotedExpiredSidePanelProps = QuotedExpiredSidePanelDispatchProps &
  QuotedExpiredSidePanelOwnProps &
  QuotedExpiredSidePanelStateProps;

const mapStateToProps = (
  state: AppState,
  { formId }: QuotedExpiredSidePanelOwnProps,
): QuotedExpiredSidePanelStateProps => {
  return {
    price: liveSelectors.getSalesAdjustedSettlementPriceFormatted(state, formId)!,
    priceType: (getLiveQuotePriceType(state, formId) ?? liveReferentialSelectors.getPriceType(state, formId))!,
    priceCurrency: liveReferentialSelectors.getCurrency(state, formId)!,
  };
};

const mapDispatchToProps = (
  dispatch: ThunkDispatch,
  { formId }: QuotedExpiredSidePanelOwnProps,
): QuotedExpiredSidePanelDispatchProps => {
  return {
    onDone: () => {
      dispatch(secondaryMarketLiveQuoteCancelRequestedThunk(formId));
    },
    onReprice: () => {
      dispatch(secondaryMarketLiveRepriceQuoteThunk(formId));
    },
  };
};

export const connectQuotedExpiredSidePanel = connect(mapStateToProps, mapDispatchToProps);

export const ConnectedQuotedExpiredSidePanel = connectQuotedExpiredSidePanel(QuotedExpiredSidePanel);
